export const createComponents = () => ({
  MuiButton: {
    styleOverrides: {
      root: {
        // textTransform is intentionally omitted here so each client
        // controls it via their own typography.button in their theme file.
      },
    },
  },
});
